/* Yoracare K-Scalp page — auto-translate to French for FR visitors.
   Detection: navigator.language first, ipapi.co fallback.
   Strategy: walk text nodes inside known Yora section containers, look up
   trimmed content in a flat dictionary, replace if matched.
   Also translates a small set of attribute values (alt, aria-label, placeholder, title). */

(function () {
  if (window.__yoraFrLoaded) return; window.__yoraFrLoaded = true;

  var DICT = {
    /* ── Hero (.ysc) ── */
    "5-star reviews": "avis 5 étoiles",
    "Korean Scalp Revival Bar": "Barre de Revitalisation du Cuir Chevelu Coréen",
    "12 Fermented Herbs": "12 Herbes Fermentées",
    "Vegan & Cruelty-Free": "Vegan & Sans Cruauté",
    "Sulfate-Free": "Sans Sulfates",
    "Dermatologist approved": "Approuvé par les dermatologues",
    "The Korean scalp ritual that clears years of buildup, calms inflammation, and wakes up follicles your liquid shampoo put to sleep.":
      "Le rituel coréen pour le cuir chevelu qui élimine des années d'accumulation, apaise l'inflammation et réveille les follicules que votre shampooing liquide a endormis.",

    /* Warning */
    "WARNING: Low Stock Notice": "ATTENTION : Stock Limité",
    "12 times": "12 fois",
    "limited sale": "vente limitée",
    "This product sold out": "Ce produit a été épuisé",
    "last year. Take advantage of the": "l'année dernière. Profitez de la",
    "and buy now. Ordering now helps you avoid future stock outs.":
      "et commandez maintenant. Commander maintenant vous aide à éviter les futures ruptures de stock.",

    /* Trust icons */
    "60-Day Guarantee": "Garantie 60 jours",
    "Free shipping": "Livraison gratuite",
    "Secure payment": "Paiement sécurisé",

    /* Mini reviews + FAQ on hero */
    "Loved by 10,000+ happy scalps": "Adorée par 10 000+ cuirs chevelus heureux",
    "How does it work?": "Comment ça fonctionne ?",
    "The bar combines fermented rice water, ginseng, and ceramides that penetrate the scalp's natural barrier. Massaging activates circulation and lets the actives revive dormant follicles while balancing sebum production.":
      "La barre combine eau de riz fermentée, ginseng et céramides qui pénètrent la barrière naturelle du cuir chevelu. Le massage active la circulation et permet aux actifs de revitaliser les follicules dormants tout en équilibrant la production de sébum.",
    "Is it safe to use?": "Est-ce sûr à utiliser ?",
    "Yes — dermatologist approved, sulfate-free, and pH-balanced. Suitable for all scalp types including sensitive, color-treated, and post-partum hair.":
      "Oui — approuvé par les dermatologues, sans sulfates et au pH équilibré. Convient à tous les types de cuir chevelu, y compris les cheveux sensibles, colorés et post-partum.",
    "How long does one bar last?": "Combien de temps dure une barre ?",
    "One bar lasts 60+ washes — about 30 days with daily use, or 2 months with every-other-day use. Equivalent to 2–3 bottles of shampoo.":
      "Une barre dure plus de 60 lavages — environ 30 jours en usage quotidien, ou 2 mois en usage tous les deux jours. L'équivalent de 2 à 3 bouteilles de shampooing.",
    "Can I use it with my existing serums?": "Puis-je l'utiliser avec mes sérums existants ?",
    "Absolutely. The bar works as a foundational scalp treatment. Apply your serums and oils after washing as usual — the cleaner scalp environment actually helps them absorb better.":
      "Absolument. La barre agit comme un traitement fondamental du cuir chevelu. Appliquez vos sérums et huiles après le lavage comme d'habitude — un cuir chevelu plus propre les aide à mieux pénétrer.",
    "Ingredients": "Ingrédients",
    "Fermented Rice Water, Korean Ginseng, Ceramide NP, Centella Asiatica, Green Tea Extract, Niacinamide, Sodium PCA, Camellia Seed Oil, Glycerin, Sodium Cocoyl Isethionate, 12 Fermented Herbs Complex.":
      "Eau de Riz Fermentée, Ginseng Coréen, Céramide NP, Centella Asiatica, Extrait de Thé Vert, Niacinamide, PCA de Sodium, Huile de Graine de Camélia, Glycérine, Cocoyl Iséthionate de Sodium, Complexe de 12 Herbes Fermentées.",
    "Shipping and Returns": "Livraison et Retours",
    "Free US shipping on all orders. International shipping available at checkout. 60-day money-back guarantee — if you don't see less shedding and healthier hair, send it back for a full refund.":
      "Livraison gratuite aux US sur toutes les commandes. Livraison internationale disponible au paiement. Garantie de remboursement de 60 jours — si vous ne constatez pas moins de chute et des cheveux plus sains, renvoyez-la pour un remboursement complet.",

    /* ── Bundles (.yob) ── */
    "Spring Sale — Limited Time Only": "Offre de Printemps — Durée Limitée",
    "Buy 1 Get 1 Free": "Achetez 1, le 2e Offert",
    "Buy 2 Get 2 Free": "Achetez 2, les 2 Suivants Offerts",
    "60-Day Supply": "Approvisionnement 60 jours",
    "120-Day Ritual": "Rituel 120 jours",
    "2 Bars": "2 Barres",
    "4 Bars": "4 Barres",
    "Most Popular": "Le plus populaire",
    "Best Value": "Meilleur prix",
    "Add to Cart": "Ajouter au panier",
    "ADD TO CART": "AJOUTER AU PANIER",
    "ADDING…": "AJOUT EN COURS…",

    /* ── Reviews (.yrev — "Loved by 10,000+ women") ── */
    "Real Reviews": "Avis Authentiques",
    "Loved by 10,000+ women": "Adorée par 10 000+ femmes",
    "Verified": "Vérifié",
    "4.9 / 5.0": "4,9 / 5,0",
    "based on 2,847+ verified reviews": "basé sur 2 847+ avis vérifiés",
    "My shedding stopped within 3 weeks. I was losing handfuls in the shower. Now barely any. The bar lathers like a dream and my scalp feels alive again.":
      "Ma chute de cheveux s'est arrêtée en 3 semaines. J'en perdais des poignées sous la douche. Maintenant à peine quelques-uns. La barre mousse comme un rêve et mon cuir chevelu se sent à nouveau vivant.",
    "Finally something that actually works on my oily-yet-flaky scalp. After 2 months I have visible new growth at my hairline. Zero irritation.":
      "Enfin quelque chose qui fonctionne réellement sur mon cuir chevelu gras et squameux. Après 2 mois, j'ai une nouvelle pousse visible à la lisière. Zéro irritation.",
    "The smell is heavenly and my hair has more body within a week. I was skeptical because I've tried so many things. This one's different.":
      "L'odeur est divine et mes cheveux ont plus de volume en une semaine. J'étais sceptique parce que j'ai essayé tant de choses. Celle-ci est différente.",

    /* ── Loox reviews (.ylx) ── */
    "Write a review": "Écrire un avis",
    "Show more reviews": "Voir plus d'avis",
    "The shape is so satisfying to use — you can really massage it into your scalp. My hair already looks healthier and I've only been using it for a month.":
      "La forme est si agréable à utiliser — on peut vraiment la masser sur le cuir chevelu. Mes cheveux ont déjà l'air plus sains et je ne l'utilise que depuis un mois.",
    "I almost didn't buy this because I've been burned so many times. But my scalp felt different after the very first wash. Like it could finally breathe.":
      "J'ai failli ne pas l'acheter parce que j'ai été déçue tant de fois. Mais mon cuir chevelu était différent dès le premier lavage. Comme s'il pouvait enfin respirer.",
    "I switched from Nioxin to this and the difference is insane. My scalp actually feels clean for the first time in years — like a real deep clean, not just a tingle.":
      "Je suis passée de Nioxin à celle-ci et la différence est dingue. Mon cuir chevelu se sent enfin propre pour la première fois depuis des années — un vrai nettoyage en profondeur, pas juste un picotement.",
    "Three weeks in and I'm already seeing baby hairs along my hairline. I spent hundreds on serums that did nothing. This little green bar did more in weeks than everything else combined.":
      "Trois semaines et je vois déjà des bébés cheveux à la lisière. J'ai dépensé des centaines sur des sérums qui ne faisaient rien. Cette petite barre verte a fait plus en quelques semaines que tout le reste réuni.",
    "My shower drain used to make me cry. Literally. I'm on my second bar now and the shedding has slowed down SO much. I actually enjoy washing my hair again.":
      "Le siphon de ma douche me faisait pleurer. Littéralement. J'en suis à ma deuxième barre et la chute a tellement diminué. J'aime à nouveau me laver les cheveux.",
    "My scalp feels refreshed n clean.": "Mon cuir chevelu se sent rafraîchi et propre.",
    "I just have it for month and use it 4 times. I like it v much. I have v sensitive scalp and regular shampoos and hair gel are no no for me but this bar feels amazing. Hopefully I'll update my review soon about more regrowing more hair.":
      "Je l'ai depuis un mois et je l'ai utilisée 4 fois. J'aime beaucoup. J'ai un cuir chevelu très sensible et les shampooings classiques et le gel ne me conviennent pas, mais cette barre est incroyable. J'espère mettre à jour mon avis bientôt avec plus de repousse.",
    "Six weeks in and my hairstylist asked what I changed. That never happens.":
      "Six semaines et ma coiffeuse m'a demandé ce que j'avais changé. Ça n'arrive jamais.",
    "Love it!": "Je l'adore !",
    "Love how my hair is falling lesser only been using it for 2 weeks and it's smell good.":
      "J'adore le fait que mes cheveux tombent moins, je ne l'utilise que depuis 2 semaines et ça sent bon.",
    "I didn't have high expectations as I have extremely oily and very fine hair and feel like I had tried almost everything out there. Was I wrong. WOW. I have never had my hair so clean and I can even go a full two days between shampoos. (This has never happened.) I haven't been on it long enough to see any hair growth but I am hopeful. New customer for life!":
      "Je n'avais pas de grandes attentes car j'ai des cheveux extrêmement gras et très fins et j'avais l'impression d'avoir tout essayé. Quelle erreur. WOW. Je n'ai jamais eu les cheveux aussi propres et je peux même tenir deux jours entre les lavages. (Ça n'est jamais arrivé.) Je ne l'utilise pas depuis assez longtemps pour voir une repousse, mais j'ai bon espoir. Nouvelle cliente à vie !",
    "My husband noticed before I did. He said 'your hair looks different — thicker'. That's when I knew this wasn't placebo. Week 6 and I'm a believer.":
      "Mon mari l'a remarqué avant moi. Il a dit \"tes cheveux ont l'air différents — plus épais\". C'est là que j'ai su que ce n'était pas un placebo. Semaine 6 et je suis convaincue.",

    /* ── Thicker hair (.yth) ── */
    "The Science": "La Science",
    "Thicker hair starts at the scalp.": "Des cheveux plus épais commencent au cuir chevelu.",
    "source": "source",
    "Within weeks, your scalp transforms. Within months, your hair does too.":
      "En quelques semaines, votre cuir chevelu se transforme. En quelques mois, vos cheveux aussi.",
    "Less shedding in 30 days": "Moins de chute en 30 jours",
    "More follicle activity": "Plus d'activité folliculaire",
    "Saw visible new growth": "Ont vu une nouvelle pousse visible",

    /* ── How it works (.yhiw) ── */
    "The Ritual": "Le Rituel",
    "How it works": "Comment ça fonctionne",
    "Glide the bar on your scalp": "Glissez la barre sur votre cuir chevelu",
    "Wet your hair, then glide the bar directly across your scalp in sections. The buttery texture activates instantly with water.":
      "Mouillez vos cheveux, puis glissez la barre directement sur le cuir chevelu par sections. La texture beurrée s'active instantanément au contact de l'eau.",
    "Massage for 60 seconds": "Massez pendant 60 secondes",
    "Use your fingertips to massage the rich lather into your scalp. This activates circulation and lets the actives penetrate deeply.":
      "Utilisez vos doigts pour faire pénétrer la mousse riche dans votre cuir chevelu. Cela active la circulation et permet aux actifs de pénétrer en profondeur.",
    "See the transformation": "Voyez la transformation",
    "Rinse thoroughly. After 2–3 weeks of consistent use, you'll notice less shedding, a calmer scalp, and visibly healthier hair.":
      "Rincez abondamment. Après 2 à 3 semaines d'utilisation régulière, vous remarquerez moins de chute, un cuir chevelu apaisé et des cheveux visiblement plus sains.",

    /* ── Why Yoracare (.ywhy) ── */
    "The Difference": "La Différence",
    "Why Moon?": "Pourquoi Moon ?",
    "Korean Botanicals": "Botaniques Coréennes",
    "Fermented rice water, ginseng, and ceramides — the same actives Korean dermatologists prescribe.":
      "Eau de riz fermentée, ginseng et céramides — les mêmes actifs prescrits par les dermatologues coréens.",
    "No harsh detergents that strip your scalp's natural barrier. Just gentle, pH-balanced cleansing.":
      "Aucun détergent agressif qui altère la barrière naturelle du cuir chevelu. Juste un nettoyage doux au pH équilibré.",
    "Lasts 60+ Washes": "Dure plus de 60 lavages",
    "One bar replaces 3 bottles of shampoo. Travel-friendly, eco-friendly, wallet-friendly.":
      "Une barre remplace 3 bouteilles de shampooing. Idéale en voyage, écologique, économique.",
    "Don't see less shedding and healthier hair? Send it back for a full refund. Zero risk.":
      "Vous ne constatez pas moins de chute et des cheveux plus sains ? Renvoyez-la pour un remboursement complet. Aucun risque.",

    /* ── FAQ (.yfaq) ── */
    "FAQ": "FAQ",
    "Frequently asked questions": "Questions fréquentes",
    "How long until I see results?": "Combien de temps avant de voir des résultats ?",
    "Most customers notice less shedding within 2–3 weeks of consistent use. Visible new growth typically appears around 6–8 weeks. Hair regeneration is a long process — we recommend 90 days for best results.":
      "La plupart des clients remarquent moins de chute en 2 à 3 semaines d'utilisation régulière. Une nouvelle pousse visible apparaît généralement vers 6 à 8 semaines. La régénération capillaire est un long processus — nous recommandons 90 jours pour de meilleurs résultats.",
    "How often should I use it?": "À quelle fréquence dois-je l'utiliser ?",
    "Use it 2–3 times per week, replacing your regular shampoo. On non-wash days, your scalp continues to benefit from the residual actives.":
      "Utilisez-la 2 à 3 fois par semaine, en remplacement de votre shampooing habituel. Les jours sans lavage, votre cuir chevelu continue de bénéficier des actifs résiduels.",
    "Is it safe for color-treated hair?": "Est-ce sans danger pour les cheveux colorés ?",
    "Yes. The bar is sulfate-free and color-safe. It actually helps preserve color longer because it doesn't strip the hair like traditional shampoos.":
      "Oui. La barre est sans sulfates et préserve la couleur. Elle aide en réalité à conserver la couleur plus longtemps car elle n'altère pas les cheveux comme les shampooings traditionnels.",
    "Will it work for my scalp type?": "Convient-elle à mon type de cuir chevelu ?",
    "The bar is formulated for all scalp types — oily, dry, combination, sensitive, and flaky. The Korean botanicals adapt to your scalp's needs over time.":
      "La barre est formulée pour tous les types de cuir chevelu — gras, sec, mixte, sensible et squameux. Les botaniques coréennes s'adaptent aux besoins de votre cuir chevelu au fil du temps.",
    "One bar lasts 60+ washes — about 30 days with daily use, or 2 months with every-other-day use. That's the equivalent of 2–3 bottles of shampoo.":
      "Une barre dure plus de 60 lavages — environ 30 jours en usage quotidien, ou 2 mois en usage tous les deux jours. C'est l'équivalent de 2 à 3 bouteilles de shampooing.",
    "What's your return policy?": "Quelle est votre politique de retour ?",
    "60-day money-back guarantee. If you don't see less shedding and healthier hair, send it back for a full refund. No questions asked.":
      "Garantie de remboursement de 60 jours. Si vous ne constatez pas moins de chute et des cheveux plus sains, renvoyez-la pour un remboursement complet. Sans question."
  };

  /* Attribute translations (alt, aria-label, placeholder, title) */
  var ATTR_DICT = {
    "Korean Scalp Revival Bar": "Barre de Revitalisation du Cuir Chevelu Coréen",
    "View image": "Voir l'image",
    "Filter": "Filtrer",
    "Previous": "Précédent",
    "Next": "Suivant",
    "Jump to customer reviews": "Aller aux avis clients",
    "Sarah K. before & after": "Sarah K. avant & après",
    "Emma R. before & after": "Emma R. avant & après",
    "Mia L. before & after": "Mia L. avant & après"
  };

  /* Some short suffix patterns we want to translate even when they appear as
     part of a parent string (e.g. inside <strong> spans). Maps a short EN
     token to its FR replacement. */
  var SHORT_DICT = {
    "WARNING: Low Stock Notice": "ATTENTION : Stock Limité",
    "limited sale": "vente limitée",
    "12 times": "12 fois",
    "Sarah K.": "Sarah K.",
    "Emma R.": "Emma R.",
    "Mia L.": "Mia L."
  };

  function isFrenchByLang() {
    var lang = (navigator.language || navigator.userLanguage || '').toLowerCase();
    return lang.indexOf('fr') === 0;
  }

  function alreadyDecided() {
    try { return sessionStorage.getItem('yoraFrLocale'); } catch (_) { return null; }
  }
  function rememberLocale(loc) {
    try { sessionStorage.setItem('yoraFrLocale', loc); } catch (_) {}
  }

  function detectLocale(callback) {
    /* If query string forces a locale (testing) */
    try {
      var qs = new URLSearchParams(location.search);
      if (qs.get('locale') === 'fr' || qs.get('lang') === 'fr') return callback('fr');
      if (qs.get('locale') === 'en' || qs.get('lang') === 'en') return callback('en');
    } catch (_) {}

    var cached = alreadyDecided();
    if (cached) return callback(cached);

    if (isFrenchByLang()) { rememberLocale('fr'); return callback('fr'); }

    /* IP geo fallback — only if not French by browser */
    var done = false;
    var t = setTimeout(function () {
      if (done) return; done = true;
      rememberLocale('en'); callback('en');
    }, 1500);

    fetch('https://ipapi.co/json/').then(function (r) { return r.json(); }).then(function (j) {
      if (done) return; done = true; clearTimeout(t);
      var cc = (j && j.country_code) ? String(j.country_code).toUpperCase() : '';
      var loc = (cc === 'FR' || cc === 'BE' || cc === 'LU' || cc === 'MC' || cc === 'CH') ? 'fr' : 'en';
      rememberLocale(loc); callback(loc);
    }).catch(function () {
      if (done) return; done = true; clearTimeout(t);
      rememberLocale('en'); callback('en');
    });
  }

  function normalize(s) {
    return s.replace(/\s+/g, ' ').trim();
  }

  /* USD → EUR price formatter.
     Display-only conversion — Shopify still charges in store currency at checkout.
     Strategy: match "$XX.XX" or "$X" and rewrite as "XX,XX €" (French format,
     symbol after, comma decimal, space before €). Same numeric value (parity)
     — for true FX conversion the merchant must use Shopify Markets / Currency. */
  var PRICE_RE = /\$\s*([0-9]{1,4})(?:\.([0-9]{2}))?/g;
  function convertPricesInString(s) {
    return s.replace(PRICE_RE, function (_m, intPart, decPart) {
      if (decPart === undefined) return intPart + ' €';
      return intPart + ',' + decPart + ' €';
    });
  }
  function hasPrice(s) { return /\$\s*[0-9]/.test(s); }

  var SCOPE_SELECTOR = '.ysc, .yob, .yrev, .ylx, .yth, .yhiw, .ywhy, .yfaq, .ysat';
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, IFRAME: 1, SVG: 1, CODE: 1, KBD: 1, SAMP: 1 };

  function translateTextNodes(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || !n.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        var p = n.parentElement;
        if (!p) return NodeFilter.FILTER_REJECT;
        if (SKIP_TAGS[p.tagName]) return NodeFilter.FILTER_REJECT;
        if (p.closest('[data-no-fr-translate]')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var node;
    while ((node = walker.nextNode())) {
      var raw = node.nodeValue;
      var key = normalize(raw);
      if (DICT[key]) {
        var prefix = raw.match(/^\s*/)[0];
        var suffix = raw.match(/\s*$/)[0];
        var translated = DICT[key];
        if (hasPrice(translated)) translated = convertPricesInString(translated);
        node.nodeValue = prefix + translated + suffix;
        continue;
      }
      /* Try short-token replace inside the text (for things wrapped in <strong>) */
      var changed = raw;
      Object.keys(SHORT_DICT).forEach(function (k) {
        if (changed.indexOf(k) !== -1) changed = changed.split(k).join(SHORT_DICT[k]);
      });
      /* Always check for $-prices and convert to €-format */
      if (hasPrice(changed)) changed = convertPricesInString(changed);
      if (changed !== raw) node.nodeValue = changed;
    }
  }

  function translateAttributes(root) {
    var els = root.querySelectorAll('[alt], [aria-label], [placeholder], [title]');
    els.forEach(function (el) {
      ['alt', 'aria-label', 'placeholder', 'title'].forEach(function (a) {
        if (!el.hasAttribute(a)) return;
        var v = el.getAttribute(a);
        var k = normalize(v);
        if (ATTR_DICT[k]) el.setAttribute(a, ATTR_DICT[k]);
      });
    });
  }

  function translateAll() {
    var roots = document.querySelectorAll(SCOPE_SELECTOR);
    if (!roots.length) return;
    roots.forEach(function (r) { translateTextNodes(r); translateAttributes(r); });
    document.documentElement.setAttribute('lang', 'fr');
  }

  function run() {
    detectLocale(function (loc) {
      if (loc !== 'fr') return;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', translateAll);
      } else {
        translateAll();
      }
      /* Re-run after dynamic UI mutations (cart drawer renders, accordion expands, etc.) */
      var rerunTimer = null;
      var observer = new MutationObserver(function () {
        clearTimeout(rerunTimer);
        rerunTimer = setTimeout(translateAll, 60);
      });
      var start = function () {
        document.querySelectorAll(SCOPE_SELECTOR).forEach(function (n) {
          observer.observe(n, { childList: true, subtree: true, characterData: true });
        });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
      else start();
    });
  }

  run();
})();
